import { useEffect, useState } from 'react'
import { api } from '../../lib/api.js'
import CanvaNavigator from './CanvaNavigator.jsx'
import { CANVA_ROOT_ID } from './engine/canvaFolders.js'
import { isDemo } from './engine/flags.js'
import styles from './MarksLibrary.module.css'

/**
 * Elements — read-only browse of the SR Canva library, now using the SAME
 * FOLDER NAVIGATOR the element pickers use (previously a flat search that
 * rendered folders as dead cards you couldn't open).
 *
 * The connection gate stays: /api/canva/status tells the rep plainly when Canva
 * isn't linked yet, rather than showing an empty grid and letting them guess.
 * Picking a design opens it in Canva; nothing here creates or edits anything.
 */
export default function CanvaPicker() {
  const demo = isDemo()
  const [state, setState] = useState(demo ? 'ready' : 'checking') // checking|ready|disconnected

  useEffect(() => {
    if (demo) return
    let alive = true
    api.canvaStatus()
      .then((s) => { if (alive) setState(s && s.connected === false ? 'disconnected' : 'ready') })
      // A status route that errors shouldn't hide the library — let the
      // navigator try, and it reports its own failure honestly.
      .catch(() => { if (alive) setState('ready') })
    return () => { alive = false }
  }, [demo])

  return (
    <div className={styles.wrap}>
      <section className={styles.section}>
        <div className={styles.queueHead}>
          <div className="eyebrow">Canva elements</div>
        </div>

        {state === 'checking' ? (
          <div className={styles.canvaGrid}>
            {Array.from({ length: 4 }).map((_, i) => <div key={i} className={styles.canvaSkel} />)}
          </div>
        ) : state === 'disconnected' ? (
          <div className={styles.empty}>
            Canva isn’t connected yet — an admin can link it from the backend OAuth flow.
          </div>
        ) : (
          <CanvaNavigator
            rootFolder={CANVA_ROOT_ID}
            onPick={(item) => {
              const href = item.edit || item.url
              if (href) window.open(href, '_blank', 'noopener,noreferrer')
            }}
          />
        )}
      </section>
    </div>
  )
}
